import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { RouteConstants } from "@core/constants/route.constants";
import { UserService } from "@core/services";

@Injectable({ providedIn: 'root' })
export class DisableAdminAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isAdmin = this.userService.checkCurrentUserIsAdmin();
    if (isAdmin) {
      return this.router.navigate([RouteConstants.ADMIN_MODULE.COMPANY_MANAGER]);
    } else {
      return true;
    }
  }
}
